import { combineReducers } from '@reduxjs/toolkit';
import schedulesSlice from './slice';
import { domainReducers } from './domains';

export default combineReducers({
  entity: schedulesSlice.reducer,
  domains: domainReducers,
});
